import React from "react";

function ReceivableDetails({ object }) {
  return (
    <div className="border rounded  p-2 max-w-3xl mx-auto">
      {/* <h6 className="text-lg font-semibold text-gray-700 mb-4">
        Details - Component
      </h6> */}
      {/* <hr /> */}
      <div className="">
        <p className="m-0">
          <strong className="font-medium">DR # :</strong> {object?.["dr#"]}
        </p>
        <p className="m-0">
          <strong className="font-medium">DR Type :</strong> {object?.drType}
        </p>
        <p className="m-0">
          <strong className="font-medium">Remarks :</strong> {object?.remarks}
        </p>
      </div>
    </div>
  );
}

export default ReceivableDetails;
